import { render, staticRenderFns } from "./CurrentOrdersTableMobile.vue?vue&type=template&id=557e98a6&scoped=true"
import script from "./CurrentOrdersTableMobile.vue?vue&type=script&lang=js"
export * from "./CurrentOrdersTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e98a6",
  null
  
)

export default component.exports